import React, { useEffect, useState } from "react";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import {
  UserListingService,
  UserListingSearchService,
  DepartmentListingService,
  RoleListingService,
  UserTypeListingService,
} from "../../services/UserOnboardingService";
import UserList from "./UserList";
import { BASE_URL } from "../../utils/AppApiUrl";
import useGlobalState from "../../Context";

const UsersDetails = () => {
  const { showNotification } = useNotificationContext();
  // const [tableLoader, setTableLoader] = useState(false);
  const { setLoading } = useLoading();
  const [userRecords, setUserRecords] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [departmentList, setDepartmentList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [userTypeList, setUserTypeList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  // const auth = JSON.parse(localStorage.getItem("SPMS_INTERNAL_STATE"));
  const [{ auth }, ] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;

  useEffect(() => {
    fetchUsersDetails("firstName", false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 
  const fetchUsersDetails = async (sortBy, isAsc,searchValue,paginationData) => {
    try {
      setLoading(true);
      const requestBody = {
        status: loginUserType === "Main Admin" ? 2 : 0,
        pageNumber: paginationData?.pageNumber ?? 0,
        pageSize: paginationData?.pageSize ?? 10,
        filterSearch: searchValue ? searchValue :null,
        sortBy: sortBy,
        sortDirection: isAsc ? "DESC" : "ASC",
      };
      const userListingResponse = await UserListingService(
        BASE_URL,
        requestBody
      );
      if (userListingResponse.statusCode === 6) {
        if (userListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setUserRecords(userListingResponse.data.content);
        setTotalElements(userListingResponse.data.totalElements);
      } else {
        showNotification("Error", userListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartmentList = async () => {
    try {
      const requestBody = {
        pageSize: 200,
        pageNumber: 0,
        filterSearch: null,
        active: 0,
        sortDirection: "ASC",
        sortBy: "name",
      };
      const departmentListingResponse = await DepartmentListingService(requestBody);
      if (departmentListingResponse.statusCode === 6) {
       
        setDepartmentList(departmentListingResponse.data.content);
      } else {
        showNotification("Error", departmentListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoleList = async () => {
    try {

      const requestObject = {
        pageNumber: 0,
        pageSize: 200,
        filterSearch: null,
        active: 0,
        //categoryId: null,
        sortDirection: "ASC",
        sortBy: "name",
      };

      const roleListingResponse = await RoleListingService(requestObject);
      if (roleListingResponse.statusCode === 6) {
       setRoleList(roleListingResponse.data.content);
      } else {
        showNotification("Error", roleListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchUserTypeList = async (userType) => {
    try {
      const userTypeListingResponse = await UserTypeListingService();
      if (userTypeListingResponse.statusCode === 6) {
       // console.log('userTypeListingResponse',userTypeListingResponse.data)
        if (loginUserType === "Domain Admin") {
          if (userType === "Domain Admin") {
            const userTypeList = userTypeListingResponse.data.filter(
              (item) => item.name !== "Main Admin"
            );
            setUserTypeList(userTypeList);
          } else {
            setUserTypeList(userTypeListingResponse.data);
          }
        } else {
          
          setUserTypeList(userTypeListingResponse.data);
        }
      } else {
        showNotification("Error", userTypeListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const onSearchUser = async (BASE_URL, values, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        status: loginUserType === "Main Admin" ? 2 : 0,
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortBy: "firstName",
        sortDirection: "ASC",
      };
      const userListingResponse = await UserListingSearchService(
        BASE_URL,
        requestBody,
        searchValue
      );
      //console.log('test in index',userListingResponse)
      if (userListingResponse.statusCode === 6) {
        if (userListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setUserRecords(userListingResponse.data.content);
        setTotalElements(userListingResponse.data.totalElements);
      } else {
        showNotification("Error", userListingResponse.message, "error");
      }
    } catch (err) {
      //console.log('err',err)
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    searchValue
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        status: loginUserType === "Main Admin" ? 2 : 0,
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        sortBy: orderBy,
        sortDirection: sortValue === null ? "DESC" : sortValue,
        filterSearch: searchValue ? searchValue.trim(): null,
      };
      // setTableLoader(true);
      const response = await UserListingService(BASE_URL, requestBody);
      if (response.statusCode === 6) {
        if (isUpdate) {
          setUserRecords([...userRecords, ...response.data.content]);
        } else {
          setUserRecords(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  return (
    <>
      <UserList
        userRecords={userRecords}
        handleTableChanges={handleTableChanges}
        fetchUsersDetails={fetchUsersDetails}
        totalElements={totalElements}
        setUserRecords={setUserRecords}
        setTotalElements={setTotalElements}
        BASE_URL={BASE_URL}
        onSearchUser={onSearchUser}
        fetchDepartmentList={fetchDepartmentList}
        fetchRoleList={fetchRoleList}
        fetchUserTypeList={fetchUserTypeList}
        departmentList={departmentList}
        roleList={roleList}
        userTypeList={userTypeList}
        setLoading={setLoading}
        showNotification={showNotification}
        noRecord={noRecord}
      />
    </>
  );
};
export default UsersDetails;
